import { Path } from 'constants/router'
import type { PfStep } from 'models/purchaseFlowRevamp'

/** Steps a resume can reopen directly. Configuration needs a tab to open, which the catalogue's Proceed picks. */
const RESUMABLE_STEP_PATH: Partial<Record<PfStep, string>> = {
  instructions: Path.PURCHASE_FLOW_REVAMP_INSTRUCTIONS,
  billing: Path.PURCHASE_FLOW_REVAMP_BILLING,
  summary: Path.PURCHASE_FLOW_REVAMP_SUMMARY,
}

/**
 * Where a resumed draft opens: the step it was saved on, when the entry would land on the catalogue anyway.
 * Any other entry (an admin still choosing the client, a draft with no property) wins, since those must come first.
 */
export const resolveResumePath = (entryPath: string, lastStep: PfStep | undefined): string => {
  if (entryPath !== Path.PURCHASE_FLOW_REVAMP_CATALOGUE || !lastStep) return entryPath
  return RESUMABLE_STEP_PATH[lastStep] ?? entryPath
}
